const NoPage = () => {
    return (
      <div className="content">
        <h1>Oops</h1>
        <p>The page you are looking for doesn't exist.</p>
      </div>
    );
  };
  
  export default NoPage;